import React from "react";
import { InlineMath } from "react-katex";

export const FIGURE_NAMES = { lumberjack: "drwala", snowman: "bałwana", rocket: "rakiety" };

// A shared boundary is an edge; meeting at a single point is not adjacency.
export function coloringFigure(shape, count) {
  if (![5, 6, 7].includes(count)) throw new Error("Unsupported region count");
  if (shape === "lumberjack") {
    const regions = [
      { path: "M115 55 Q90 40 130 30 L150 5 L165 25 L180 5 L205 30 Q245 40 205 55 Q160 70 115 55Z", at: [160, 40] },
      { path: "M115 55 Q160 70 205 55 Q210 95 175 112 L145 112 Q110 95 115 55Z", at: [160, 88] },
      { path: `M145 112 L145 125 L105 135 L60 260 L85 270 L120 175 L125 250 L195 250 L200 175 ${count === 7 ? "L218.8 226 L242.7 212" : "L235 270 L260 260"} L215 135 L175 125 L175 112Z`, at: [160, 195] },
      { path: "M125 250 L195 250 L215 375 L250 375 L247 393 L190 400 L160 290 L130 400 L73 393 L70 375 L105 375Z", at: [145, 278] },
      { path: count === 5 ? "M60 260 L85 270 L50 350 L45 375 L10 365 L20 330 L25 340Z" : "M60 260 L85 270 L50 350 L25 340Z", at: [51, 308] },
    ];
    const edges = [[0, 1], [1, 2], [2, 3], [2, 4]];
    if (count >= 6) { regions.push({ path: "M25 340 L50 350 L45 375 L10 365 L20 330Z", at: [29, 358] }); edges.push([4, 5]); }
    if (count === 7) { regions.push({ path: "M218.8 226 L242.7 212 L260 260 L235 270Z", at: [239, 244] }); edges.push([2, 6]); }
    return { regions, edges, viewBox: "0 0 280 415" };
  }
  if (shape === "rocket") {
    const regions = Array.from({ length: count }, (_, i) => ({
      path: i === 0 ? "M100 70 L160 10 L220 70Z" : i === count - 1
        ? `M100 ${70 + 44 * (i - 1)} L220 ${70 + 44 * (i - 1)} L255 ${114 + 44 * (i - 1)} L200 ${114 + 44 * (i - 1)} L160 ${134 + 44 * (i - 1)} L120 ${114 + 44 * (i - 1)} L65 ${114 + 44 * (i - 1)}Z`
        : `M100 ${70 + 44 * (i - 1)} H220 V${114 + 44 * (i - 1)} H100Z`,
      at: [160, i === 0 ? 52 : 92 + 44 * (i - 1)],
    }));
    return { regions, edges: regions.slice(1).map((_, i) => [i, i + 1]), viewBox: `50 0 220 ${100 + 44 * count}` };
  }
  if (shape === "snowman") {
    const regions = [
      { path: "M90 60 V45 H120 V10 H200 V45 H230 V60Z", at: [160, 38] },
      { path: "M125 60 H195 Q230 95 195 130 H125 Q90 95 125 60Z", at: [160, 97] },
    ];
    for (let i = 2; i < count; i++) {
      const y = 130 + 48 * (i - 2), half = 35 + 14 * (i - 2), next = half + 14;
      regions.push({ path: `M${160 - half} ${y} H${160 + half} Q${175 + next} ${y + 24} ${160 + next} ${y + 48} H${160 - next} Q${145 - next} ${y + 24} ${160 - half} ${y}Z`, at: [160, y + 28] });
    }
    return { regions, edges: regions.slice(1).map((_, i) => [i, i + 1]), viewBox: `35 0 250 ${150 + 48 * (count - 2)}` };
  }
  throw new Error("Unknown coloring figure");
}

export default function RegionColoringDiagram({ shape, count }) {
  const { regions, viewBox } = coloringFigure(shape, count);
  return <svg viewBox={viewBox} role="img" aria-label={`Rysunek ${FIGURE_NAMES[shape]}: ${count} ponumerowanych obszarów`} style={{ width: "min(100%, 300px)", height: 390, display: "block", margin: "20px auto" }}>
    {regions.map((region, i) => <g key={i}><path d={region.path} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" /><foreignObject x={region.at[0]-18} y={region.at[1]-13} width="36" height="28"><div xmlns="http://www.w3.org/1999/xhtml" style={{textAlign:"center",fontSize:15,color:"inherit"}}><InlineMath math={String(i+1)}/></div></foreignObject></g>)}
  </svg>;
}
